import http from 'hub-http/clients/apiClient';
import hublessHttp from 'hub-http/clients/noPortalApiClient';
const API_BASE = 'userpreferences/v1/attributes';
export default class AttributesAPI {
  static getAttributes({
    hubless
  }) {
    if (hubless) {
      return hublessHttp.get(`${API_BASE}/hubless`);
    }
    return http.get(API_BASE);
  }
  static updateUnsubscribeLink(link) {
    return http.put(`${API_BASE}/unsubscribe-link`, {
      data: link,
      headers: {
        'content-type': 'text/plain'
      }
    });
  }
  static updateLanguageAndLocale(languageAndLocale) {
    return hublessHttp.put(`${API_BASE}/language-and-locale/hubless`, {
      data: languageAndLocale
    });
  }
  static updateDefaultPhoneCountryCode(countryCode) {
    return hublessHttp.put(`${API_BASE}/default-phone-country-code`, {
      data: countryCode,
      headers: {
        'content-type': 'text/plain'
      }
    });
  }
  static updatePhoneNumber(phoneNumber) {
    return hublessHttp.put(`${API_BASE}/phoneNumber`, {
      data: phoneNumber,
      headers: {
        'content-type': 'text/plain'
      }
    });
  }
  static updateDefaultHome(homeKey) {
    return http.put('/navconfig/v2/home/options', {
      data: homeKey,
      headers: {
        'content-type': 'text/plain'
      }
    });
  }
}